// extracted by css-extract-rspack-plugin
export default {"cards":"ResourcesSection-module__cards__BY5IzbI"};